import React from 'react';
import { useTranslation } from 'react-i18next';

interface ProfileTabsProps {
	activeTab: number;
	onTabClick: (index: number) => void;
}

const ProfileTabs: React.FC<ProfileTabsProps> = ({ activeTab, onTabClick }) => {
	const { t } = useTranslation();

	return (
		<div className="tabs">
			<div
				className={`tab-test-profile ${activeTab === 0 ? 'tab-active' : ''}`}
				onClick={() => onTabClick(0)}>
				<div className={`circle ${activeTab === 0 ? 'circle-active' : ''}`}>1</div>
				<div className={`text-test-profile ${activeTab === 0 ? 'text-test-profile-active' : ''}`}>
					{t('register.testProfile.step_1.name')}
				</div>
			</div>
			<div
				className={`tab-test-profile ${activeTab === 1 ? 'tab-active' : ''}`}
				onClick={() => onTabClick(1)}>
				<div className={`circle ${activeTab === 1 ? 'circle-active' : ''}`}>2</div>
				<div className={`text-test-profile ${activeTab === 1 ? 'text-test-profile-active' : ''}`}>
					{t('register.testProfile.step_2.name')}
				</div>
			</div>
			<div
				className={`tab-test-profile ${activeTab === 2 ? 'tab-active' : ''}`}
				onClick={() => onTabClick(2)}>
				<div className={`circle ${activeTab === 2 ? 'circle-active' : ''}`}>3</div>
				<div className={`text-test-profile ${activeTab === 2 ? 'text-test-profile-active' : ''}`}>
					{t('register.testProfile.step_3.name')}
				</div>
			</div>
		</div>
	);
};

export default ProfileTabs;
